module.exports = __webpack_public_path__ + "img/order.59eb5699.svg";